/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

// Curated Fonts list source:
// https://github.com/google/web-stories-wp/issues/1989#issuecomment-662253222
export const curatedFontNames = [
  'Karla',
  'Lato',
  'Lora',
  'Merriweather',
  'Montserrat',
  'Nunito',
  'Oswald',
  'Playfair Display',
  'Poppins',
  'Raleway',
  'Roboto',
  'Roboto Condensed',
  'Source Serif 4',
  'Titillium Web',
  'Work Sans',
  'Alegreya',
  'Arimo',
  'EB Garamond',
  'IBM Plex Mono',
  'IBM Plex Serif',
  'Inconsolata',
  'Mulish',
  'Noto Sans',
  'Noto Serif',
  'Open Sans',
  'PT Mono',
  'PT Sans',
  'PT Serif',
  'Source Sans 3',
  'Ubuntu',
  'Anton',
  'BioRhyme',
  'Bungee',
  'Bungee Shade',
  'Cookie',
  'Dancing Script',
  'Monoton',
  'Nothing You Could Do',
  'Parisienne',
  'Rock Salt',
  'UnifrakturMaguntia',
];
